export default "__VITE_ASSET__cd4340b5__"